/**
 * Base class for menu tab content
 * Separated to avoid circular dependencies
 */

import { UIComponent } from './components';
import { Player } from '@client/entities/Player';

export abstract class MenuTabContent extends UIComponent {
  protected player: Player;

  constructor(player: Player) {
    super({
      width: 'fill',
      height: 'fill',
    });
    this.player = player;
  }

  // Called when tab becomes active
  onActivate(): void {}

  // Called when tab becomes inactive
  onDeactivate(): void {}

  // Called every frame while active
  abstract update(deltaTime: number): void;
}
